export const GLOBAL_STATE = 'AssessmentOffence'

export const ASSESSMENT_OFFENCE = 'ASSESSMENT_OFFENCE' as const
export const ASSESSMENT_OFFENCE_CREATE = 'ASSESSMENT_OFFENCE_CREATE' as const
export const ASSESSMENT_OFFENCE_ALL = 'ASSESSMENT_OFFENCE_ALL' as const
export const ASSESSMENT_OFFENCE_DELETE = 'ASSESSMENT_OFFENCE_DELETE' as const
export const ASSESSMENT_OFFENCE_INVIGILATION = 'ASSESSMENT_OFFENCE_INVIGILATION' as const
export const ASSESSMENT_OFFENCE_INVIGILATION_CREATE = 'ASSESSMENT_OFFENCE_INVIGILATION_CREATE' as const
export const ASSESSMENT_OFFENCE_INVIGILATION_ALL = 'ASSESSMENT_OFFENCE_INVIGILATION_ALL' as const
export const ASSESSMENT_OFFENCE_INVIGILATION_DELETE = 'ASSESSMENT_OFFENCE_INVIGILATION_DELETE' as const
export const ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS = 'ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS' as const
export const ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_CREATE =
  'ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_CREATE' as const
export const ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL =
  'ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL' as const
export const ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_DELETE =
  'ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_DELETE' as const
export const ASSESSMENT_OFFENCE_INVIGILATION_MINUTES = 'ASSESSMENT_OFFENCE_INVIGILATION_MINUTES' as const
export const ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_CREATE = 'ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_CREATE' as const
export const ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL = 'ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL' as const
export const ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_DELETE = 'ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_DELETE' as const

export const ASSESSMENT_OFFENCE_TYPE = 'ASSESSMENT_OFFENCE_TYPE' as const
export const ASSESSMENT_OFFENCE_TYPE_CREATE = 'ASSESSMENT_OFFENCE_TYPE_CREATE' as const
export const ASSESSMENT_OFFENCE_TYPE_ALL = 'ASSESSMENT_OFFENCE_TYPE_ALL' as const
export const ASSESSMENT_OFFENCE_TYPE_DELETE = 'ASSESSMENT_OFFENCE_TYPE_DELETE' as const
export const ASSESSMENT_OFFENCE_REPORT_LIST = 'ASSESSMENT_OFFENCE_REPORT_LIST' as const
export const ASSESSMENT_OFFENCE_REPORT_ALL = 'ASSESSMENT_OFFENCE_REPORT_ALL' as const
export const ASSESSMENT_OFFENCE_REPORT_CREATE = 'ASSESSMENT_OFFENCE_REPORT_CREATE' as const
export const ASSESSMENT_OFFENCE_CHANGE_STATUS = 'ASSESSMENT_OFFENCE_CHANGE_STATUS' as const
export const ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS = 'ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS' as const
export const ASSESSMENT_OFFENCE_PUBLISH = 'ASSESSMENT_OFFENCE_PUBLISH' as const
export const ASSESSMENT_OFFENCE_UNPUBLISH = 'ASSESSMENT_OFFENCE_UNPUBLISH' as const
export const REPORT_MISCONDUCT = 'REPORT_MISCONDUCT' as const
